/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountAmount,
  DiscountAmountOptional,
  DiscountAmountMetaI,
  DiscountAmountTrackedI,
} from "./discount-amount";
import { DiscountAmountTracked, DiscountAmountMeta } from "./discount-amount";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountBase,
  DiscountBaseOptional,
  DiscountBaseMetaI,
  DiscountBaseTrackedI,
} from "./discount-base";
import { DiscountBaseTracked, DiscountBaseMeta } from "./discount-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountInstanceRef,
  DiscountInstanceRefOptional,
  DiscountInstanceRefMetaI,
  DiscountInstanceRefTrackedI,
} from "./discount-instance-ref";
import {
  DiscountInstanceRefTracked,
  DiscountInstanceRefMeta,
} from "./discount-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountType,
  DiscountTypeOptional,
  DiscountTypeMetaI,
  DiscountTypeTrackedI,
} from "./discount-type";
import { DiscountTypeTracked, DiscountTypeMeta } from "./discount-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportDTO,
  ReportDTOOptional,
  ReportDTOMetaI,
  ReportDTOTrackedI,
} from "./report-dto";
import { ReportDTOTracked, ReportDTOMeta } from "./report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";

/**
 *
 * @export
 * @interface CatalogItemInstanceDiscountReportDTO
 */
export interface CatalogItemInstanceDiscountReportDTOOptional extends DiscountAmountOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  percent?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  discountName?: string;
  /**
   *
   * @type {DiscountInstanceRef}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  discountInstance?: DiscountInstanceRefOptional;
}

export interface CatalogItemInstanceDiscountReportDTO
  extends
    CatalogItemInstanceDiscountReportDTOOptional,
    DiscountAmount,
    DiscountBase,
    ReportDTO {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  typeCounts?: ReportTypeCountDTO[];
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  percent?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  discountName: string;
  /**
   *
   * @type {DiscountInstanceRef}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  discountInstance?: DiscountInstanceRef;
}

export interface CatalogItemInstanceDiscountReportDTOTrackedI extends DiscountAmountOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  discountType?: DiscountType;
  discountTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  amountCents?: number;
  amountCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  percent?: string;
  percentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  discountName?: string;
  discountNameIsSet: boolean;
  /**
   *
   * @type {DiscountInstanceRef}
   * @memberof CatalogItemInstanceDiscountReportDTO
   */
  discountInstance?: DiscountInstanceRefTrackedI;
  discountInstanceIsSet: boolean;
}

transformDatesMap.set(
  "CatalogItemInstanceDiscountReportDTO",
  function (model: CatalogItemInstanceDiscountReportDTO) {
    const transformDateschildReports = transformDatesMap.get("ReportDTO");
    if (transformDateschildReports) {
      model.childReports?.forEach((sub) => {
        transformDateschildReports(sub);
      });
    }
    const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
    if (transformDatesmeta) {
      model.meta?.forEach((sub) => {
        transformDatesmeta(sub);
      });
    }
    const transformDatestypeCounts =
      transformDatesMap.get("ReportTypeCountDTO");
    if (transformDatestypeCounts) {
      model.typeCounts?.forEach((sub) => {
        transformDatestypeCounts(sub);
      });
    }
    const transformDatesdiscountInstance = transformDatesMap.get(
      "DiscountInstanceRef",
    );
    if (transformDatesdiscountInstance && model.discountInstance) {
      transformDatesdiscountInstance(model.discountInstance);
    }
  },
);

export type CatalogItemInstanceDiscountReportDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  discountType: PropertyMeta<DiscountTypeMetaI>;
  //isDate: false
  //isDatetime: false
  amountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  percent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  discountName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  discountInstance: PropertyMeta<DiscountInstanceRefMetaI>;
}>;

export var CatalogItemInstanceDiscountReportDTOMeta: CatalogItemInstanceDiscountReportDTOMetaI =
  {} as CatalogItemInstanceDiscountReportDTOMetaI;
CatalogItemInstanceDiscountReportDTOMeta = typeMeta(
  "CatalogItemInstanceDiscountReportDTO",
  {
    isDeleted: propertyMeta(
      "isDeleted",
      false,
      false,
      false,
      MetaTypesBase.boolean,
    ),
    isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
    reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
    reportKey: propertyMeta(
      "reportKey",
      false,
      true,
      false,
      MetaTypesBase.string,
    ),
    reportTitle: propertyMeta(
      "reportTitle",
      false,
      false,
      false,
      MetaTypesBase.string,
    ),
    reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
    reportStatus: propertyMeta(
      "reportStatus",
      false,
      false,
      false,
      ReportStatusMeta,
    ),
    childReports: propertyMeta(
      "childReports",
      true,
      false,
      false,
      ReportDTOMeta,
    ),
    meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
    typeCounts: propertyMeta(
      "typeCounts",
      true,
      false,
      false,
      ReportTypeCountDTOMeta,
    ),
    discountType: propertyMeta(
      "discountType",
      false,
      false,
      false,
      DiscountTypeMeta,
    ),
    amountCents: propertyMeta(
      "amountCents",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
    percent: propertyMeta("percent", false, false, false, MetaTypesBase.string),
    discountName: propertyMeta(
      "discountName",
      false,
      true,
      false,
      MetaTypesBase.string,
    ),
    discountInstance: propertyMeta(
      "discountInstance",
      false,
      false,
      false,
      DiscountInstanceRefMeta,
    ),
  },
);

const metaI = CatalogItemInstanceDiscountReportDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ReportDTOMeta]);
  metaI.isDeleted.inheritedFrom = ReportDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = ReportDTOMeta.isNew;
  metaI.reportId.inheritedFrom = ReportDTOMeta.reportId;
  metaI.reportKey.inheritedFrom = ReportDTOMeta.reportKey;
  metaI.reportTitle.inheritedFrom = ReportDTOMeta.reportTitle;
  metaI.reportType.inheritedFrom = ReportDTOMeta.reportType;
  metaI.reportStatus.inheritedFrom = ReportDTOMeta.reportStatus;
  metaI.childReports.inheritedFrom = ReportDTOMeta.childReports;
  metaI.meta.inheritedFrom = ReportDTOMeta.meta;
  metaI.typeCounts.inheritedFrom = ReportDTOMeta.typeCounts;
  metaI.interfaces = metaI.interfaces.concat([DiscountAmountMeta]);
  metaI.discountType.inheritedFrom = DiscountAmountMeta.discountType;
  metaI.amountCents.inheritedFrom = DiscountAmountMeta.amountCents;
  metaI.percent.inheritedFrom = DiscountAmountMeta.percent;
  metaI.interfaces = metaI.interfaces.concat([DiscountBaseMeta]);
  metaI.discountName.inheritedFrom = DiscountBaseMeta.discountName;
});

export class CatalogItemInstanceDiscountReportDTOTracked
  extends DiscountAmountTracked
  implements CatalogItemInstanceDiscountReportDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  discountType__I?: DiscountType = undefined;
  discountTypeIsSet: boolean = false;
  set discountType(v: undefined | DiscountType) {
    if (v !== undefined) {
      this.discountType__I = v;
      this.discountTypeIsSet = true;
    } else {
      this.discountType__I = v || undefined;
      this.discountTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountType() {
    return this.discountType__I;
  }
  amountCents__I?: number = undefined;
  amountCentsIsSet: boolean = false;
  set amountCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCents__I = v;
      this.amountCentsIsSet = true;
    } else {
      this.amountCents__I = v || undefined;
      this.amountCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountCents() {
    return this.amountCents__I;
  }
  percent__I?: string = undefined;
  percentIsSet: boolean = false;
  set percent(v: undefined | string) {
    if (v !== undefined) {
      this.percent__I = v;
      this.percentIsSet = true;
    } else {
      this.percent__I = v || undefined;
      this.percentIsSet = false;
    }
    this.changeTracker = true;
  }
  get percent() {
    return this.percent__I;
  }
  discountName__I?: string = undefined;
  discountNameIsSet: boolean = false;
  set discountName(v: undefined | string) {
    if (v !== undefined) {
      this.discountName__I = v;
      this.discountNameIsSet = true;
    } else {
      this.discountName__I = v || undefined;
      this.discountNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get discountName() {
    return this.discountName__I;
  }
  discountInstance__I?: DiscountInstanceRefTracked = undefined;
  discountInstanceIsSet: boolean = false;
  set discountInstance(v: undefined | DiscountInstanceRefTracked) {
    if (v !== undefined) {
      this.discountInstance__I = v;
      this.discountInstanceIsSet = true;
    } else {
      this.discountInstance__I = v || undefined;
      this.discountInstanceIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountInstance() {
    return this.discountInstance__I;
  }
  constructor(
    config?: CatalogItemInstanceDiscountReportDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());

    this.discountInstance?.setIds();
  }
  assignFrom(
    config: CatalogItemInstanceDiscountReportDTOOptional,
    options?: AssignOptions,
  ): CatalogItemInstanceDiscountReportDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (
      config.discountType &&
      this.discountTypeApplyFilter(optionsRequired.filter)
    ) {
      this.discountType = config.discountType;
      if (optionsRequired.unassign) this.discountTypeIsSet = false;
      else this.discountTypeIsSet = true;
    }
    if (
      config.amountCents &&
      this.amountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCents = config.amountCents;
      if (optionsRequired.unassign) this.amountCentsIsSet = false;
      else this.amountCentsIsSet = true;
    }
    if (config.percent && this.percentApplyFilter(optionsRequired.filter)) {
      this.percent = config.percent;
      if (optionsRequired.unassign) this.percentIsSet = false;
      else this.percentIsSet = true;
    }
    if (
      config.discountName &&
      this.discountNameApplyFilter(optionsRequired.filter)
    ) {
      this.discountName = config.discountName;
      if (optionsRequired.unassign) this.discountNameIsSet = false;
      else this.discountNameIsSet = true;
    }
    if (
      config.discountInstance &&
      this.discountInstanceApplyFilter(optionsRequired.filter)
    ) {
      this.discountInstance = new DiscountInstanceRefTracked(
        config.discountInstance,
        options,
      );
      if (optionsRequired.unassign) this.discountInstanceIsSet = false;
      else this.discountInstanceIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(
    filter?: FilterVarsType,
  ): CatalogItemInstanceDiscountReportDTOTrackedI {
    const cloned = {} as CatalogItemInstanceDiscountReportDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (
      this.discountTypeIsSetDeep() &&
      this.discountTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountTypeIsSet = true;
      cloned.discountType = this.discountType;
    } else {
      //cloned.discountTypeIsSet = false
    }
    if (
      this.amountCentsIsSetDeep() &&
      this.amountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCentsIsSet = true;
      cloned.amountCents = this.amountCents;
    } else {
      //cloned.amountCentsIsSet = false
    }
    if (
      this.percentIsSetDeep() &&
      this.percentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.percentIsSet = true;
      cloned.percent = this.percent;
    } else {
      //cloned.percentIsSet = false
    }
    if (
      this.discountNameIsSetDeep() &&
      this.discountNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountNameIsSet = true;
      cloned.discountName = this.discountName;
    } else {
      //cloned.discountNameIsSet = false
    }
    if (
      this.discountInstanceIsSetDeep() &&
      this.discountInstanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountInstanceIsSet = true;
      cloned.discountInstance = this.discountInstance?.removeUnset(filter);
    } else {
      //cloned.discountInstanceIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(
    filter?: FilterVarsType,
  ): CatalogItemInstanceDiscountReportDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    if (!this.discountTypeApplyFilter(filter)) this.discountTypeIsSet = false;

    if (!this.amountCentsApplyFilter(filter)) this.amountCentsIsSet = false;

    if (!this.percentApplyFilter(filter)) this.percentIsSet = false;

    if (!this.discountNameApplyFilter(filter)) this.discountNameIsSet = false;

    if (!this.discountInstanceApplyFilter(filter))
      this.discountInstanceIsSet = false;
    this.discountInstance?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.isDeleted,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.isNew,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.reportId,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.reportId,
      this,
    );
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.reportKey,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.reportTitle,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.reportType,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.reportStatus,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.childReports,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.meta,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.meta,
      this,
    );
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.typeCounts,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  discountTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.discountType,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.discountType,
      this,
    );
  }
  discountTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountTypeIsSet && this.discountTypeApplyFilter(filter))
      return true;

    return false;
  }
  amountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.amountCents,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.amountCents,
      this,
    );
  }
  amountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountCentsIsSet && this.amountCentsApplyFilter(filter))
      return true;

    return false;
  }
  percentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.percent,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.percent,
      this,
    );
  }
  percentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.percentIsSet && this.percentApplyFilter(filter)) return true;

    return false;
  }
  discountNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.discountName,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.discountName,
      this,
    );
  }
  discountNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountNameIsSet && this.discountNameApplyFilter(filter))
      return true;

    return false;
  }
  discountInstanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDiscountReportDTOMeta.discountInstance,
      CatalogItemInstanceDiscountReportDTOMeta,
      this.discountInstance,
      this,
    );
  }
  discountInstanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountInstanceIsSet && this.discountInstanceApplyFilter(filter))
      return true;
    return this.discountInstance?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    if (this.discountTypeIsSetDeep(filter)) return true;
    if (this.amountCentsIsSetDeep(filter)) return true;
    if (this.percentIsSetDeep(filter)) return true;
    if (this.discountNameIsSetDeep(filter)) return true;
    if (this.discountInstanceIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
